export const NAVIGATE_TO_INVALID_ROUTES = '*';
export const NAVIGATE_TO_HOME = '/';
export const NAVIGATE_TO_LOGIN = '/login';